export function normalizeExtension(filename: string) {
  const parts = filename.split(".");
  if (parts.length === 1) {
    return filename;
  }
  const extension = parts.pop()!.toLowerCase();
  const nameWithoutExtension = parts.join(".");
  return `${nameWithoutExtension}.${extension}`;
}
